/**
* Service Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-tabs__splide' ).length ) {
        $( '.service-tabs__splide' ).each( function( index, element ) {
          const splide = new Splide( $( element )[0], {
            type: 'loop',
            perPage: 1,
            gap: '32px',
            drag: true,
            pagination: false,
            arrows: true,
          } );
          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              pagination: isOverflow,
              drag: isOverflow,
            };
          } );
          splide.mount( );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-tabs', COMPONENT );
} )( app );
